import { render, staticRenderFns } from "./ReportTemplate.vue?vue&type=template&id=12ed3a56"
import script from "./ReportTemplate.vue?vue&type=script&lang=js"
export * from "./ReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports